/**
 * @generated SignedSource<<7f53f122dad6da76fdf7c74ed57e810f>>
 * @relayHash 078ea28cfe1d9a3c2d2ee0fc1d972dc1
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 078ea28cfe1d9a3c2d2ee0fc1d972dc1

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type ShiftInformation = "MEDICAL_SUPERVISOR" | "NON_OPERATIVE_SHIFT" | "OPERATIVE_SHIFT";
export type ShiftPlanRoleFilter = "CALL_CENTER_AGENTS" | "DOCTORS_AND_MEDICAL_SUPERVISORS" | "NURSING_PROFESSIONALS";
export type SkillSpecialty = "CARDIOLOGY" | "DERMATOLOGY" | "GENERAL_INTERNAL_MEDICINE" | "GYNAECOLOGY" | "LONG_COVID" | "OTORHINOLARYNGOLOGY" | "PEDIATRICS" | "RHEUMATOLOGY" | "SPORTS_MEDICINE" | "STUDY" | "SURGERY" | "TELE_GENERAL_PRACTITIONER" | "UROLOGY" | "VACCINATION_ADVICE";
export type Team = "DERMATOLOGY" | "PEDIATRICS" | "PSYCHOSOCIAL";
export type ShiftPlanFilterInput = {
  agents?: ReadonlyArray<string> | null;
  languages?: ReadonlyArray<Language> | null;
  licenses?: ReadonlyArray<Country> | null;
  qualifications?: ReadonlyArray<string> | null;
  shiftTypes?: ReadonlyArray<string> | null;
  specialties?: ReadonlyArray<SkillSpecialty> | null;
  teams?: ReadonlyArray<Team> | null;
};
export type useShiftPlanOverviewQuery$variables = {
  date: any;
  filters?: ShiftPlanFilterInput | null;
  roleFilter: ShiftPlanRoleFilter;
};
export type useShiftPlanOverviewQuery$data = {
  readonly shiftPlanOverview: ReadonlyArray<{
    readonly isNurse: boolean;
    readonly isOperationsLead: boolean;
    readonly languages: ReadonlyArray<Language>;
    readonly licenses: ReadonlyArray<Country>;
    readonly qualifications: ReadonlyArray<string>;
    readonly shifts: ReadonlyArray<{
      readonly shiftEnd: string;
      readonly shiftInformation: ShiftInformation | null;
      readonly shiftStart: string;
      readonly shiftType: string;
    }>;
    readonly specialties: ReadonlyArray<SkillSpecialty>;
    readonly teams: ReadonlyArray<Team>;
    readonly userName: string;
  }>;
};
export type useShiftPlanOverviewQuery = {
  response: useShiftPlanOverviewQuery$data;
  variables: useShiftPlanOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "roleFilter"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "date",
        "variableName": "date"
      },
      {
        "kind": "Variable",
        "name": "filters",
        "variableName": "filters"
      },
      {
        "kind": "Variable",
        "name": "roleFilter",
        "variableName": "roleFilter"
      }
    ],
    "concreteType": "ShiftPlanAgentOutput",
    "kind": "LinkedField",
    "name": "shiftPlanOverview",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isNurse",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isOperationsLead",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "specialties",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "languages",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teams",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "licenses",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "qualifications",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ShiftPlanShiftOutput",
        "kind": "LinkedField",
        "name": "shifts",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shiftStart",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shiftEnd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shiftType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shiftInformation",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useShiftPlanOverviewQuery",
    "selections": (v3/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v2/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useShiftPlanOverviewQuery",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "id": "078ea28cfe1d9a3c2d2ee0fc1d972dc1",
    "metadata": {},
    "name": "useShiftPlanOverviewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8912ae469f83f42a2766dc6f172c5884";

export default node;
